module.exports = __webpack_public_path__ + "img/stable.99f5c94d.jpg";